

function refreshCart() {
	$.ajax({
	  url: '/cart?view=sidecart',
	  dataType: 'HTML',
	  method: "GET",
	  success: function (htmlData) {
        let html_markup = $(htmlData); 
        let data_replace = $(htmlData).html();
        $('.cart_test').html(data_replace);
        console.log(data_replace)
        // let cart_count = $(`[data-cart-itemcount]`).attr('data-cart-itemcount');
        // $('.js_cart_total').text(cart_count);
        // console.log(cart_count);
        // $('#headercart').dropdown('toggle'); 
        openCart();
	 }
	});
  }



 
$(document).ready(function(){ 

    // ========================== Faq accordian =================================================

    if($('.js-faq-accordian').length > 0) {
        $('.js-faq-accordian .js-faq-accordian-item:nth-child(1)').addClass('active');
        $('.js-faq-accordian .js-faq-accordian-item:nth-child(1) .js-faq-accordian-inner').slideDown();
        $('.js-faq-accordian-btn').on('click', function(e) {
              e.preventDefault();
              if($(this).parent('.js-faq-accordian-item').hasClass('active')) {
                $(this).siblings('.js-faq-accordian-inner').slideUp();
                $(this).parent('.js-faq-accordian-item').removeClass('active');
              }
              else {
                $('.js-faq-accordian-inner').slideUp();
                $('.js-faq-accordian-item').removeClass('active');
                $(this).siblings('.js-faq-accordian-inner').slideToggle();
                $(this).parent('.js-faq-accordian-item').toggleClass('active');
              }
        });
    }


    // ============ Product Slider ==============

    if($('.js-product-details-slider').length > 0) {
        $('.js-product-details-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            lazyLoad: 'progressive',
            asNavFor: '.js-product-details-slider-nav'
        });
    }
    if($('.js-product-details-slider-nav').length > 0) {
        $('.js-product-details-slider-nav').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: '.js-product-details-slider',
            dots: false,
            arrows: false,
            lazyLoad: 'progressive',
            focusOnSelect: true,
            responsive: [
                {
                  breakpoint: 576,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                  }
                },
              ]         
        });
    }


    // Product quantity add remove start here

    if($('.js-product-quantity-add').length > 0) {
        $('.js-product-quantity-add').click(function () {
            if ($(this).prev().val() < 10) {
            $(this).prev().val(+$(this).prev().val() + 1);
            }
        });
    }
    
    if($('.js-product-quantity-remove').length > 0) {
        $('.js-product-quantity-remove').click(function () {
            if ($(this).next().val() > 1) {
            if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
            }
        });
    }
    
    // Product quantity add remove end here


//collection cart update  end


    // ============ What's Included Slider ==============

    if($('.js-whats-included-slider').length > 0) {
        $('.js-whats-included-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots:true,
            lazyLoad: 'progressive'
        });
    }

    
    // Call Product collection slider

    collectionSlider();

    $(window).resize(function(){
        collectionSlider();
    });
});



function collectionSlider() {
    if($('.js-collection-slider').length > 0) {
        if ($(window).width() < 768) { 
            $('.js-collection-slider').slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                dots:false,
                responsive: [
                    {
                      breakpoint: 481,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                      }
                    },
                ]
            });
         }
         else {
            $('.js-collection-slider').slick('unslick');
         }
        
    }
}

function openCart() {
    
      // Toggle menu js start here
      if($('.js-product-cart').length > 0) {
        
        $('.js-product-cart').addClass('open');
        $('body').addClass('cart-open');
        $('.js-product-cart-close-btn').on('click',function(){
            $('.js-product-cart').removeClass('open');
             $('body').removeClass('cart-open');
        });
    
        $(document).mouseup(function(e) {
                if (!$('.js-product-cart').is(e.target) && $('.js-product-cart').has(e.target).length === 0) 
                {
                    $('.js-product-cart').removeClass('open');
                    $('body').removeClass('cart-open');
                }
        });

      }
  

    // Toggle menu js end here 

}
// ============ scroll to js start ==============
	jQuery('.scrollTo').click(function(e) {
        var jump = jQuery(this).attr('href');
        var new_position = jQuery(jump).offset();
        var scroll = 0;
        jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800, function(){
            var new_position = jQuery(jump).offset();
            jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800);
        });
        e.preventDefault();
    });


// ============ scroll to js end ==============

// ============ collection add to cart ==============


$( document ).ready(function() {
  // Handler for .ready() called.
  var shop_url = $('.coll-filter').attr('data-shop');
  var collection_url = $('.coll-filter').attr('data-url');
  var collFilters = jQuery('.coll-filter');
  collFilters.change(function() {    
    var currentValue = jQuery(this).val();
    if (typeof currentValue != "undefined" && currentValue != null && currentValue != "") 
    {
      //window.location.href =  'https://www.urbanhydration.com/collections/skin-care/' + currentValue +'?view=cw-collection-bundle';
      window.location.href =  shop_url + collection_url +'/' + currentValue +'?view=cw-collection-bundle';
    }
        });
  });


  
// PRODUCT PAGE ATC JS START
$(document).ready(function(){
  
  $(document).on('click', '.js-product-atc', function (e) {
    e.preventDefault();
    var target = e.target;
    var data_id = $(this).attr("data-id");
    var quantity = $('.productquantityselect input[data-qty-id="'+data_id +'"]').val();
    $.ajax({
      url :   "/cart/add.js",
      method : "POST",
      dataType : "JSON",
      data : {id : data_id , quantity : quantity},
      success : function() {
       //window.location = "/cart";
       refreshCart();
     
     jQuery.getJSON('/cart.js', function (cart, textStatus) {
                      $('.cart-item-count-header--quantity').text(cart.item_count);
                     });
      }
    });

  });



  $(document).on('click', '.js-product-quantity-add', function (e) {
    
     
    let parent = $(e.target).parents('.js_cart_qty').eq(0);
    let current_qty = $(parent).attr('data-quantity');
    let updated_qty = parseInt(current_qty) + 1;
    //window.js_cart_value++;
   
    let current_item = {};
    let key = $(parent).attr('data-key');
    current_item[key] = updated_qty;
    $.ajax({
      url: "/cart/update.js",
      data: {
        'updates': current_item
      },
      method: "POST",
      dataType: "JSON",
      success: function (data) {
        refreshCart(data);      
      },
      
      error: function (error) {
        console.log(error)
      }
      
    });
  });

  $(document).on('click', '.js-product-quantity-remove', function (e) {
        let parent = $(e.target).parents('.js_cart_qty').eq(0);
        let current_qty = $(parent).attr('data-quantity');
        let updated_qty = parseInt(current_qty) - 1;
        //window.js_cart_value--;
        let current_item = {};
        if (updated_qty <= 0) {
          updated_qty = 0;
        }
        let key = $(parent).attr('data-key');
        current_item[key] = updated_qty;
        $.ajax({
          url: "/cart/update.js",
          data: {
            'updates': current_item
          },
          method: "POST",
          dataType: "JSON",
          success: function (data) {
            refreshCart();
          },
          error: function (error) {
            console.log(error)
          }
        });
      });
      
      $(document).on('click', '.collection_page_atc', function (e) {

        e.preventDefault();
        let current_em = $(e.target);
        let current_this_elm = $(this);
        let parent = $(e.target).parents(".js_col_product").eq(0);
        let variant_id = $(parent).find(this).attr("data-id");
        //let variant_id = $('.js-variant-selector').val();
           
        let quantity = 1;
        let data = {};
        data.id = variant_id;
        data.quantity = quantity;
        
          let compare = 0;
          $(this).each(function(em, ix) {
              //let parent = $(e.target).parents(".js_col_product").eq(0);
             
              let price = $(this).attr("data-com-price"); 
              compare += parseInt(price);
             // totalPrice += parseInt(totalPrice);
             
              });
         
        $.ajax({
          url: "/cart/add.js",
          method: "POST",
          dataType: "JSON",
          data: data,
          success: function (data) {
                  jQuery.getJSON('/cart.js', function(cart) {
                      // now have access to Shopify cart object
                    console.log(cart);
                      let total = cart.items_subtotal_price;
                      $('.js_total_price').html(Shopify.formatMoney(total, $('body').data('money-format')));
                      var cartCompareTotalPrice = 0;
                      let savePrice = 0;  
                      cart.items.forEach((em,ix) => {
                       $('[data-var-id]').each((index,element) => {
                       
                        if($(element).data('var-id') === em.id){
        
                          console.log($(element).data('var-id'));
                          console.log('quantity', em.quantity);
                          console.log($(element).data('com-price'));
                          if($(element).data('com-price') == ''){
                               cartCompareTotalPrice += em.price*em.quantity;
                               savePrice += em.price*em.quantity - em.price*em.quantity;
                          }else{
                               cartCompareTotalPrice += $(element).data('com-price')*em.quantity;
                               savePrice += $(element).data('com-price')*em.quantity - em.price*em.quantity;
                          }
                        }
                        
                       });
                      } );
                       
                      $('.js_compare_total').html(Shopify.formatMoney(cartCompareTotalPrice, $('body').data('money-format')));
        
                      $('.js_save_col_price').html(Shopify.formatMoney(savePrice, $('body').data('money-format')));
                      $('.cart-item-count-header--quantity').text(cart.item_count);
                  } );
                  
                  current_this_elm.html("Add More <span class='button__icon'>+</span>");
                  $(parent).find('.bundles__message').show();
                  
          },
          error: function (error) {
            alert("Sorry, that option is not available currently!");
            return false;
        
          }
            });
        });
        


 });


 


